import { notifyAnalytics } from '@/api/analytics/notifyAnalytics'
import {
  ALL_CHARGERS_ENDPOINT
} from '@/api/clients/charger-database-client'
import { keycloak } from '@/main'
import type { Location as apiLocation, CDB_locations_query_params } from '@/types/charger_Db_types'

/**
 * Fetches all chargers from the charger database.
 *
 * @returns A promise that resolves with the full list of charger records from the charger database or undefined if an error occurs.
 */
export async function fetchPublicChargers(params?:CDB_locations_query_params): Promise<apiLocation[] | undefined> {
  try {
    const endpoint = ALL_CHARGERS_ENDPOINT + (params ? '?' + new URLSearchParams(params as any).toString() : '')
    const response = await fetch(endpoint, { method: 'GET' })
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const result = await response.text()
    return JSON.parse(result)
  } catch (error) {
    if (error instanceof SyntaxError) {
      // If JSON parsing fails, rethrow the error
      throw error
    } else {
      if (import.meta.env.MODE === 'development') {
        if (import.meta.env.VITE_VERBOSE_MODE === 'true')
          console.error('Fetching chargerDB public charger data failed.', error)
      } else notifyAnalytics({ type: 'log_error', data: error })
      return undefined
    }
  }
}

export async function fetchPrivateAndPublicChargers(params?:CDB_locations_query_params): Promise<apiLocation[] | undefined> {
  try {
    const token = keycloak.token
    const endpoint = ALL_CHARGERS_ENDPOINT + (params ? '?' + new URLSearchParams(params as any).toString() : '')

    const response = await fetch(endpoint, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const result = await response.text()
    return JSON.parse(result)
  } catch (error) {
    if (error instanceof SyntaxError) {
      // If JSON parsing fails, rethrow the error
      throw error
    } else {
      if (import.meta.env.MODE === 'development') {
        if (import.meta.env.VITE_VERBOSE_MODE === 'true')
          console.error('Fetching chargerDB private and public charger data failed.', error)
      } else notifyAnalytics({ type: 'log_error', data: error })
      return undefined
    }
  }
}
